import React from 'react';
import { Box, Paper, Grid } from '@mui/material';
import { LineChart, Line, AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar, CartesianGrid, Legend } from 'recharts';
import KPIGrid from '../components/KPIGrid';
import ChartCard from '../components/ChartCard';

const ExecutiveTab = ({ data }) => {
    if (!data) return <div>Loading...</div>;

    const { kpis, dauSeries, revenueSeries, signupSeries } = data;

    return (
        <Box height="100%">
            {/* KPI Row */}
            <KPIGrid kpis={kpis} />

            <Grid container spacing={3}>
                {/* Main Charts - Stacked Vertically */}
                <Grid item xs={12}>
                    <Grid container spacing={3} direction="column">
                        <Grid item xs={12}>
                             <ChartCard title="DAU Trend">
                                <LineChart data={dauSeries}>
                                    <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                                    <XAxis dataKey="date" hide />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Line type="monotone" dataKey="value" stroke="#8884d8" name="DAU" activeDot={{ r: 8 }} />
                                </LineChart>
                            </ChartCard>
                        </Grid>
                        <Grid item xs={12}>
                            <ChartCard title="Revenue Trend (Daily)">
                                <AreaChart data={revenueSeries}>
                                    <defs>
                                        <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
                                            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
                                        </linearGradient>
                                    </defs>
                                    <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                                    <XAxis dataKey="date" tickFormatter={(str) => {
                                        const date = new Date(str);
                                        return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
                                    }} minTickGap={30} />
                                    <YAxis />
                                    <Tooltip formatter={(val) => `$${val}`} labelFormatter={(label) => new Date(label).toDateString()} />
                                    <Legend />
                                    <Area type="monotone" dataKey="value" stroke="#82ca9d" fillOpacity={1} fill="url(#colorRevenue)" name="Revenue" dot={false} />
                                </AreaChart>
                            </ChartCard>
                        </Grid>
                        <Grid item xs={12}>
                            <ChartCard title="New Signups">
                                <BarChart data={signupSeries}>
                                    <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                                    <XAxis dataKey="date" tickFormatter={(str) => {
                                        const date = new Date(str);
                                        return date.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
                                    }} minTickGap={30} />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="value" fill="#ffc658" name="Signups" />
                                </BarChart>
                            </ChartCard>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ExecutiveTab;
